import { string } from 'prop-types';
import React from 'react';

import SvgIcon from 'ravenjs/lib/SvgIcon';
import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const ArrowSendIcon = ({ fill, height, viewBox, width, ...rest }) => {
    return (
        <SvgIcon
            {...rest}
            width={width}
            height={height}
            viewBox={viewBox}
            fill={fill}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.67484 17.5L19.1665 10L1.67484 2.5L1.6665 8.33333L14.1665 10L1.6665 11.6667L1.67484 17.5Z"
                fill={fill}
            />
        </SvgIcon>
    );
};

ArrowSendIcon.propTypes = {
    fill: string,
    height: string,
    viewBox: string,
    width: string,
};

ArrowSendIcon.defaultProps = {
    fill: MIGRATED_COLORS.informationBlue900,
    height: '20',
    viewBox: '0 0 20 20',
    width: '20',
};

export default ArrowSendIcon;
